import { SET_JOB_IN_STORE } from '../constants/types';

const initialState = {
    job: {}
}

export default function( state = initialState , action ){
    switch (action.type){
        case SET_JOB_IN_STORE:
            return{
                ...state,
                job: action.payload
            }
        default:
            return state;
    }
}